var _path, _circle, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCall = function SvgCall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0004 43C34.5983 43 44.0004 33.598 44.0004 22C44.0004 10.402 34.5983 1 23.0004 1C12.7702 1 4.24858 8.31512 2.38086 18",
    stroke: "#1D2026",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 22,
    r: 2,
    stroke: "#1D2026",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 22L25 22",
    stroke: "#1D2026",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 6.5V20",
    stroke: "#1D2026",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 24H6.45837C6.65394 24 6.75172 24 6.83626 24.0315C6.91096 24.0594 6.97791 24.1047 7.03153 24.1637C7.09221 24.2305 7.12853 24.3213 7.20116 24.5029L8.74697 28.3674C8.83682 28.5921 8.88175 28.7044 8.87716 28.8117C8.87311 28.9063 8.84229 28.9978 8.78827 29.0756C8.72698 29.1638 8.62325 29.2261 8.41578 29.3505L7.13178 30.1209C6.91006 30.254 6.7992 30.3205 6.73571 30.4209C6.68228 30.5054 6.65335 30.6175 6.6592 30.7173C6.66614 30.8359 6.72669 30.9404 6.84777 31.1494C7.80989 32.8099 9.19008 34.1901 10.8506 35.1522C11.0596 35.2733 11.1641 35.3339 11.2827 35.3408C11.3825 35.3466 11.4946 35.3177 11.5791 35.2643C11.6795 35.2008 11.746 35.0899 11.8791 34.8682L12.6495 33.5842C12.7739 33.3768 12.8362 33.273 12.9244 33.2117C13.0022 33.1577 13.0937 33.1269 13.1883 33.1228C13.2956 33.1182 13.4079 33.1632 13.6326 33.253L17.4971 34.7988C17.6787 34.8715 17.7695 34.9078 17.8363 34.9685C17.8953 35.0221 17.9406 35.089 17.9685 35.1637C18 35.2483 18 35.3461 18 35.5416V39C18 39.5304 17.7893 40.0391 17.4142 40.4142C17.0391 40.7893 16.5304 41 16 41C12.0993 40.763 8.42015 39.1065 5.65683 36.3432C2.8935 33.5798 1.23705 29.9007 1 26C1 25.4696 1.21071 24.9609 1.58579 24.5858C1.96086 24.2107 2.46957 24 3 24Z",
    fill: "white",
    stroke: "#3953FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/call.7962b62b.svg";
export { ForwardRef as ReactComponent };